export default {"src":"/_next/static/media/parks.02cec4fe.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};